import { useAsync } from "./useAsync";
import * as api from "../lib/api";

/** Fetch all active bundles for the public dance library. */
export function useBundleList() {
  return useAsync(() => api.getBundleList(), []);
}

/** Fetch one active bundle for the public routine detail page. */
export function useBundleItem(bundleId: string | null) {
  return useAsync(
    () => api.getBundleItem(bundleId!),
    bundleId ? [bundleId] : null,
  );
}

/** Fetch all bundles for admin management. */
export function useAdminBundles() {
  return useAsync(() => api.getAdminBundles(), []);
}
